import { render, staticRenderFns } from "./RollUserBetsElement.vue?vue&type=template&id=63de8ce1&scoped=true"
import script from "./RollUserBetsElement.vue?vue&type=script&lang=js"
export * from "./RollUserBetsElement.vue?vue&type=script&lang=js"
import style0 from "./RollUserBetsElement.vue?vue&type=style&index=0&id=63de8ce1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63de8ce1",
  null
  
)

export default component.exports